import React from "react";
interface Prop {
  [a: string]: any;
}

export const State = React.createContext<Prop>({});
